import { CSSProperties } from 'react'
import Colors from 'modules/Colors'

interface DashboardIconProps {
    className?: string
    style?: CSSProperties
    color?: string
    size?: number
    onClick?: () => void
}

const DashboardIcon = ({
    className,
    style,
    color = Colors.purple,
    size = 24,
    onClick
}: DashboardIconProps) => {
    return (
        <svg
            className={className}
            style={style}
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={onClick}
        >
            <path
                d="M17.1104 3.40157H7.51208C6.50484 3.40278 5.53911 3.80357 4.82689 4.51566C4.1148 5.22789 3.714 6.19361 3.7128 7.20085V16.7991C3.714 17.8064 4.1148 18.7721 4.82689 19.4843C5.53911 20.1964 6.50484 20.5972 7.51208 20.5984H17.1104C18.1176 20.5972 19.0833 20.1964 19.7956 19.4843C20.5077 18.7721 20.9085 17.8064 20.9097 16.7991V7.20085C20.9084 6.19361 20.5077 5.22789 19.7956 4.51566C19.0833 3.80357 18.1176 3.40277 17.1104 3.40157ZM19.7099 16.7991C19.7091 17.4883 19.435 18.149 18.9476 18.6363C18.4603 19.1237 17.7996 19.3978 17.1104 19.3986H7.51208C6.82289 19.3978 6.16218 19.1237 5.6749 18.6363C5.18747 18.149 4.91337 17.4883 4.91259 16.7991V7.20078C4.91339 6.51159 5.18749 5.85089 5.6749 5.3636C6.16218 4.87618 6.82285 4.60208 7.51208 4.60129H17.1104C17.7996 4.6021 18.4603 4.8762 18.9476 5.3636C19.435 5.85089 19.7091 6.51156 19.7099 7.20078V16.7991Z"
                fill={color}
            />
            <path
                d="M17.3401 8.24705C17.2674 8.21665 17.1895 8.20098 17.1106 8.20071H14.711C14.4966 8.20071 14.2986 8.31507 14.1915 8.50066C14.0843 8.68625 14.0843 8.91496 14.1915 9.10055C14.2986 9.28615 14.4966 9.4005 14.711 9.4005H15.662L13.0313 12.028L11.0412 10.701C10.9259 10.6242 10.7875 10.5897 10.6495 10.6033C10.5115 10.6171 10.3827 10.6782 10.2846 10.7762L7.08523 13.9756H7.0851C6.96606 14.0866 6.8971 14.2411 6.89429 14.404C6.89147 14.5667 6.95481 14.7236 7.06997 14.8388C7.18499 14.9538 7.34193 15.0171 7.50463 15.0143C7.66746 15.0115 7.82199 14.9425 7.93299 14.8235L10.7917 11.972L12.7818 13.299H12.7817C12.8971 13.3756 13.0356 13.41 13.1735 13.3963C13.3114 13.3827 13.4404 13.3216 13.5384 13.2237L16.5139 10.249V11.2002C16.5139 11.4144 16.6283 11.6124 16.8139 11.7196C16.9995 11.8268 17.2282 11.8268 17.4138 11.7196C17.5994 11.6124 17.7137 11.4144 17.7137 11.2002V8.80059C17.7132 8.68209 17.6778 8.5664 17.612 8.46798C17.5461 8.36956 17.4527 8.29269 17.3433 8.24703L17.3401 8.24705Z"
                fill={color}
            />
        </svg>
    )
}

export default DashboardIcon
